import { Home, Users, BookOpen } from 'lucide-react';
import { cn } from '@/lib/utils';

type NavItem = {
  id: string;
  label: string;
  icon: React.ElementType;
};

const navItems: NavItem[] = [
  { id: 'home', label: 'Início', icon: Home },
  { id: 'explore', label: 'Profissionais', icon: Users },
  { id: 'articles', label: 'Artigos', icon: BookOpen },
];

interface BottomNavigationProps {
  activeItem: string;
  onItemClick: (id: string) => void;
  className?: string;
}

export function BottomNavigation({ activeItem, onItemClick, className }: BottomNavigationProps) {
  return (
    <nav
      className={cn(
        'fixed bottom-0 left-0 right-0 z-50 border-t border-white/50 bg-white/[0.55] shadow-[0_-4px_24px_rgb(15_23_42/0.06)] backdrop-blur-xl safe-area-px safe-area-pb',
        'flex items-center justify-around px-2 py-2 sm:px-4',
        className,
      )}
      aria-label="Navegação principal"
    >
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = activeItem === item.id;
        
        return (
          <button
            key={item.id}
            onClick={() => onItemClick(item.id)}
            className={cn(
              'flex min-w-0 max-w-[5.5rem] flex-1 touch-manipulation flex-col items-center gap-0.5 rounded-2xl px-1 py-2 transition-[transform,background-color,box-shadow,color] duration-500 ease-kuiva sm:px-3',
              isActive
                ? 'scale-[1.03] bg-white/60 text-kuiva-blue shadow-md ring-1 ring-kuiva-blue/20'
                : 'text-muted-foreground hover:text-kuiva-blue/80 active:scale-[0.98]',
            )}
            aria-label={item.label}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon
              className={cn(
                'h-5 w-5 transition-[transform,color] duration-500 ease-kuiva',
                isActive ? 'scale-110 text-kuiva-blue' : 'text-muted-foreground',
              )}
            />
            <span className={cn('text-xs transition-colors', isActive ? 'font-medium text-kuiva-blue' : 'text-muted-foreground')}>
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
